import _ from 'lodash'
import alphabetic from 'scoreboard/components/alphabetic'

var digit = /[0-9]/

var comparisonStrings = {

	/**
	 * Generates a comparison string based on the given string. The comparison
	 * string will only contain letters and (optionally) numbers.  Please keep
	 * this functionally the same as CmsUtil.getComparisonString.
	 *
	 * @param str
	 *            the source string
	 * @param allowNumbers
	 *            (default false) whether numbers are allowed
	 * @param allowSpaces
	 *            (default false) whether spaces are allowed
	 */
	get: function(str, allowNumbers, allowSpaces) {
		if (str == null) {
			return null
		}
		if (_.isUndefined(allowNumbers)) {
			allowNumbers = false
		}

		// do this instead of a regular expression to improve performance
		str = str.toUpperCase()
		var result = ''
		for (var i=0; i<str.length; i++) {
			var c = str.charAt(i)
			if (alphabetic.test(c) || c == '%') {
				result += c
			} else if (allowNumbers && (digit.test(c) || c == '.')) {
				//sometimes we'd like to take a look at 1's and 0's
				result += c
			} else if (allowSpaces && c == ' ') {
				// #55085
				// allow spaces in comparison strings for instances such as calendars
				result += c
			}
		}
		return result
	},

	/**
	 * Find the candidate that matches the given string
	 *
	 * @param candidates
	 *            the list of allowed matches
	 * @param str
	 *            the string to compare against each of the candidates
	 */
	match: function(candidates, str) {
		var compareStr = this.get(str)
		return _.find(candidates, function(candidate) {
			return this.get(candidate) == compareStr
		}.bind(this))
	}

}
export default comparisonStrings

comparisonStrings.__filename__ = 'scorecards/edit/comparison-strings.js'
